import { render, staticRenderFns } from "./BalanceInput.vue?vue&type=template&id=50510685&"
import script from "./BalanceInput.vue?vue&type=script&lang=js&"
export * from "./BalanceInput.vue?vue&type=script&lang=js&"
import style0 from "./BalanceInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports